import { useCallback } from "react";

import { apiClient } from "../../lib/api";

import type { ApiPayload } from "common/classes/api-payload";

export function useRegister(): (
  email: string,
  password: string,
  firstName: string,
  lastName: string,
  turnstileToken?: string,
) => Promise<ApiPayload> {
  const register = useCallback(
    async (
      email: string,
      password: string,
      firstName: string,
      lastName: string,
      turnstileToken?: string,
    ): Promise<ApiPayload> => {
      const response = await apiClient.createAccount(email, password, firstName, lastName, turnstileToken);

      if (!response.success) {
        throw new Error(response.message ?? `unexpectedError`);
      }

      return response;
    },
    [],
  );

  return register;
}
